import { CampaignSetupItemListingType, CampaignSetupParticipationMethod } from '../enums/campaign-setup.enum';
import { CampaignTypeEnumm, RegistrationCampaignSubTypeEnum } from './common.interfaces';

export interface ICampaignSetupStep1 {
  campaignTitle: string;
  campaignType: CampaignTypeEnumm | null;
  registrationSubType: RegistrationCampaignSubTypeEnum | null;
  desiredLaunchDate: string | null;
  campaignContact: string | null;
}

export interface ICampaignSetupStep2 {
  description: string;
  photos: string[];
  eventStartDate: string | null;
  eventEndDate: string | null;
  guidelines: string;
  pdfUploads: string[];
  disbursementAccountId: number | null;
}

export interface ICampaignCustomQuestion {
  id: string;
  type: 'text' | 'signature' | 'yes-no' | 'checkbox' | 'dropdown' | 'file-upload';
  label: string;
  required: boolean;
  options?: string[];
}

export interface ICampaignVolunteerShift {
  id: string;
  title: string;
  eventDate: string;
  startTime: string;
  endTime: string;
  quantity: number;
}

export interface ICampaignOption {
  id: string;
  title: string;
  price: number | null;
  quantity: number | null;
  listingType: CampaignSetupItemListingType;
  participationMethod: CampaignSetupParticipationMethod | null;
  sendTaxReceipts: boolean;
  recognitionCards: boolean;
  passProcessingFees: boolean;
  requireApproval: boolean;
  customQuestions: ICampaignCustomQuestion[];
  // Volunteer-specific
  eventDate: string | null;
  startTime: string | null;
  endTime: string | null;
  isMultiDay: boolean;
  hasShifts: boolean;
  shifts: ICampaignVolunteerShift[];
  // Ticketing-specific
  isFreeTicket: boolean;
  ticketStartDate: string | null;
  ticketEndDate: string | null;
}

export interface ICampaignSetupStep3 {
  options: ICampaignOption[];
}

export interface ICampaignSetupStep4 {
  additionalDetails: string;
  promotionalFlyer: boolean;
}

export interface ICampaignSetupPayload {
  step1: ICampaignSetupStep1;
  step2: ICampaignSetupStep2;
  step3: ICampaignSetupStep3;
  step4: ICampaignSetupStep4;
}
